import React from 'react';

import { Field } from '@hrlogics/react-components/form';

import { DateRangeField } from 'src/components/finalForm';

import { InboxFilterFieldProps, InboxFilterFormFields } from '../types';

export const InboxFilterDateCreatedField: React.FC<InboxFilterFieldProps> = ({ disabled }) => {
  return (
    <Field
      label="Date Created"
      fullWidth
      component={DateRangeField}
      name={InboxFilterFormFields.dateCreated}
      disabled={disabled}
    />
  );
};
